import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import AccountListing from "../views/AccountListing.vue";
import ChangePassword from "../views/ChangePassword.vue";
import DeviceListing from "@/views/DeviceListing.vue";
import Login from "@/views/Login.vue";
import Files from "../views/Files.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "Login",
    component: Login
  },
  {
    path: "/account-listing",
    name: "AccountListing",
    component: AccountListing
  },
  {
    path: "/device-listing",
    name: "DeviceListing",
    component: DeviceListing
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: ChangePassword
  },
  {
    path: "/files",
    name: "Files",
    component: Files
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
